import { useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react'
import { intercom } from '../core'

export default function useHideIntercom() {
  useIonViewDidEnter(() => intercom.hideWidget())
  useIonViewWillLeave(() => intercom.showWidget())
}
